import { h } from 'preact';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import classNames from 'classnames';

// Actions
import { prevStepAction } from '../../actions/Section';

// Components
import Icon from '../Global/Icon';
import Text from '../Global/Text';

import { actionHandler, stepHasRequiredData } from '../../utilities/form/formUtils';

const BackButton = ({ dispatch, className, label, backButtonConfig, userData, variant }) => {
  const isValidCondition = () => {
    if (Object.hasOwnProperty.call(backButtonConfig, 'requiredData')) {
      const { requiredData } = backButtonConfig;
      const isValid = stepHasRequiredData(requiredData, userData, {});
      return isValid;
    }
    return false;
  };

  const performBack = () => {
    if (backButtonConfig && backButtonConfig.actions && isValidCondition()) {
      actionHandler(backButtonConfig.actions,
        null, null, dispatch, userData);
      return;
    }
    dispatch(prevStepAction());
  };

  const buttonContainerClass = classNames('back-button button', {
    'NavigationContainerBackButton': !variant,
  });

  return (
    <div className={variant ? `${buttonContainerClass} ${className}` : `${className} `}>
      <button
        className={!variant ? `${buttonContainerClass}` : 'button'}
        onClick={(e) => performBack(e)}
        type="button"
      >
        {!variant &&
          <span>
            <Icon icon="chevronRight" fill="black"/>
          </span>
        }
        {variant &&
          <span className="back-button--icon">
            <Icon icon="arrowLeft" fill="black"/>
            <Text value="Tilbage" component="span" />
          </span>
        }
      </button>
    </div>
  );
};

export default compose(
  connect(state => {
    const {
      userData,
    } = state;
    return {
      userData,
    };
  })
)(BackButton);

BackButton.defaultProps = {
  className: '',
  label: 'go-back',
  backButtonConfig: {},
};

BackButton.propTypes = {
  dispatch: PropTypes.func.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  userData: PropTypes.object.isRequired,
  backButtonConfig: PropTypes.object,
  variant: PropTypes.string.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/Global/BackButton.jsx